import React from 'react'
import { Modal } from 'react-bootstrap';
import './VideoModal.css';
import ResponsiveEmbed from 'react-bootstrap/ResponsiveEmbed';

function VideoModalData(props) {
    // console.log(props.videoID)
    let videoUrl = `https://www.youtube.com/embed/${props.videoid}?autoplay=1&rel=0&showinfo=0&origin=https://www.gulfoilindia.com/`
    return (
        <Modal {...props} size="lg" className="video-modal" aria-labelledby="contained-modal-title-vcenter" centered>
            <Modal.Header closeButton>
            </Modal.Header>
            <ResponsiveEmbed aspectRatio="16by9">
                <iframe className="embed-responsive-item" src={videoUrl} title="Video" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
            </ResponsiveEmbed>
        </Modal>
    );
}

export default VideoModalData;